import * as React from "react"

export const exclamations = (txt) => {
  let out = txt.split("").map((c,i) => <span key={i}>{c}</span>)
  return <span id="exclamations">{out}</span>;
}
